var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"footer__content"},[_c('a-footer-address'),_c('a-footer-navigation'),_c('a-footer-social')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }